import "./CheckBoxWithComponents.scss";
import { useState } from "react";

export function CollapsibleText({ textHeader, text, showText, setShowText }) {
  return (
    <>
      <div
        className="collapsible-text-toggle"
        onClick={() => setShowText(!showText)}
      >
        <span>{textHeader}</span>
        <span className={`chevron ${showText ? "open" : ""}`}>&#9660;</span>
      </div>

      {showText && <div className="collapsible-text-value">{text}</div>}
    </>
  );
}

export function CheckboxWithCollapsibleText({
  text,
  collapsibleTextHeader,
  collapsibleText,
  checkBoxState,
  toggleCheckBox,
  disabled,
}) {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <div className="checkbox-container">
      <label className="checkbox-wrapper">
        <input
          type="checkbox"
          className="hidden-checkbox"
          checked={checkBoxState}
          onChange={(ev) => {
            toggleCheckBox(ev.target.checked);
          }}
          disabled={disabled}
        />
        <span className="custom-checkbox" />
        {text}
      </label>
      <CollapsibleText
        textHeader={collapsibleTextHeader}
        text={collapsibleText}
        showText={showDisclaimer}
        setShowText={setShowDisclaimer}
      />
    </div>
  );
}
